import { useAppState } from '../app/context.js';
import { color, layer, shadow } from '../tokens.js';

/** One toast at a time, bottom right, 2600 ms; no entry or exit animation (03 §7). */
export function Toast() {
  const { toast } = useAppState();
  if (!toast) return null;
  return <div role="status" style={{ position: 'absolute', right: 28, bottom: 32, zIndex: layer.toast, padding: '12px 18px', borderRadius: 22, background: color.paper, color: color.ink, fontSize: 14, fontWeight: 500, whiteSpace: 'nowrap', boxShadow: shadow.toast }}>{toast}</div>;
}
